(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ls-ingredient-return"] && !Shopify.designMode) return;
  try {
    const mountIngredientReturn = () => {
    document.querySelectorAll('[data-ingredient-return]').forEach((returnBar) => {
      if (returnBar.parentElement !== document.body) {
        document.body.appendChild(returnBar);
      }
    });

    document.documentElement.classList.add('has-ingredient-return');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountIngredientReturn);
  } else {
    mountIngredientReturn();
  }

  document.addEventListener('shopify:section:load', mountIngredientReturn);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-back-to-product]');

    if (!link) return;

    const referrer = document.referrer;

    if (!referrer) return;

    try {
      const referrerUrl = new URL(referrer);
      const isSameStore = referrerUrl.origin === window.location.origin;
      const isProductPage = referrerUrl.pathname.startsWith('/products/');

      if (isSameStore && isProductPage) {
        event.preventDefault();
        window.history.back();
      }
    } catch (error) {
      return;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
